export enum BookmarkType {
    Internet = '41303597-3da9-4bb4-a882-d4c4fcd9ea8f',
    Games = '068913d8-eafa-427e-9f04-68fac7556878',
}
